import { isEmpty } from 'lodash';

import { setGeometry } from '../../api/Missions/mission-methods-client';
import * as missionOps from '../../api/Missions/mission-operations';

const ATLAS_TYPE = 'atlas';
const MAPS_TYPE = 'leafletMap';
const MISSION_TYPE = 'mission';
const VIDEO_TYPE = 'video';

/**
 * From event fired (deleted), clears the geometry layer and updates database. Also update draw controls accordingly.
 *
 * @callback
 * @param {Function} getCurrentMapState - A function that gets the current variables needed from the map component.
 */
const deleteGeometry = getCurrentMapState => {
  const {
    defineGeometryActive,
    drawControl,
    editControl,
    geometryLayer,
    itemType,
    leafletMap,
    mission,
    setVideoGeometry,
    setAtlasGeometry
  } = getCurrentMapState();

  if (isEmpty(geometryLayer.getLayers())) {
    leafletMap.removeControl(editControl);
    leafletMap.addControl(drawControl);

    if (itemType === MISSION_TYPE && defineGeometryActive) {
      setGeometry(missionOps.getId(mission));
    }

    if (itemType === VIDEO_TYPE && defineGeometryActive) {
      setVideoGeometry();
    }

    if ((itemType === ATLAS_TYPE || itemType === MAPS_TYPE) && defineGeometryActive) {
      setAtlasGeometry({});
    }
  }
};

export default deleteGeometry;
